import { CSSProperties, FunctionComponent } from 'react';

import { BalanceWingConnected, useIsLargerThanWide, useGameStateSlice, useModifiers } from '@pp/core';

import { useMWGameGridSlice } from '../../../../store/slices/mwGameGrid/selectors';

import styles from './balanceCell.module.css';

export const BalanceCellConnected: FunctionComponent = () => {
  const isWide = useIsLargerThanWide();
  const isBetsOpen = useGameStateSlice.isBetsOpenStatus();
  const wideChipStackStep = useMWGameGridSlice.getDimension('wideChipStackStep');
  const mods = useModifiers(styles, 'balanceCell', { close: !isBetsOpen });
  if (!isWide) return null;
  return (
    <div className={`${styles.balanceCell} ${mods}`} style={{ '--wideChipStackStep': `${wideChipStackStep}px` } as CSSProperties}>
      <BalanceWingConnected />
    </div>
  );
};
